import { useAiInteractive } from "./aiInteractive";
import { useLogin } from "/@/store/login.js";
const notifyFunc = (jsonObj) => {
  cbOption(jsonObj);
  const AccountRealName = ["DEMO", "demo"];

  console.log("message from parent🚀 ~ jsonObj:", jsonObj);
  const loginStore = useLogin();
  const UserInfo = loginStore.getUserInfo();
  const { RealName } = UserInfo;
  // 判断是否是演示账号
  if (jsonObj.type === "check_is_demo") {
    if (AccountRealName.includes(RealName)) {
      return true;
    } else {
      return false;
    }
  }
};
const cbOption = (jsonObj) => {
  const MethodByTypeMap = new Map([
    ["close", CloseChartWindow],
    ["main_frame", AICommand],
    ["page_jump", PageJump],
  ]);

  // 执行AI通知消息
  let data = jsonObj;
  let type = data.type;

  const translateJumpType = ["page_jump"];
  if (translateJumpType.includes(type)) {
    type = "page_jump";
  }
  
  if (MethodByTypeMap.has(type)) {
    MethodByTypeMap.get(type)(data);
  }
};
// 关闭窗口
const CloseChartWindow = (data = null) => {
  const { closeChartWindow } = useAiInteractive();
  closeChartWindow();
};

// AI命令执行
const AICommand = (data) => {
  const { aiInteractive } = useAiInteractive();
  try {
    aiInteractive(data.value);
  } catch (error) {
    console.error(error);
  }
};

// 页面跳转
const PageJump = (data) => {
  const { cbPageJumpByType } = useAiInteractive();
  try {
    cbPageJumpByType(data);
  } catch (error) {
    console.error(error);
  }
};

export class ChildRegister {
  static childCallObj = null;
  static registerNotifyFunction() {
    for (let index = 0; index < window.frames.length; index++) {
      const frame = window.frames[index];
      if (frame.registerNotifyFunction) {
        ChildRegister.childCallObj = frame.registerNotifyFunction(notifyFunc);
        break;
      }
    }
  }
}
